import React from 'react';

import { useEditorTabStateSelector } from 'src/editor/editor-tab-state-registry';
import { useEditingHooks } from 'src/editor/helpers/useEditingHooks';
import { ClientTransforms } from 'src/editor/transforms';
import { useAuthorizedTransforms } from 'src/hooks';

import { GenericColorSelect } from '../shared/GenericColorSelect';

export function FontColorSelect(): JSX.Element {
  const { AuthorizedTransforms } = useAuthorizedTransforms();
  const { currentUserId, editingMode, editor, editorLoading } = useEditingHooks();
  const fontColor = useEditorTabStateSelector(state => state.derived.fontProperties.fontColor);

  function selectFontColor(color: string | null): void {
    if (!currentUserId || !color || !editingMode) return;

    AuthorizedTransforms.applyFontColor(editor, {
      authorId: currentUserId,
      color,
      editingMode,
    });
    ClientTransforms.focus(editor);
  }

  return (
    <GenericColorSelect
      color={fontColor}
      editorLoading={editorLoading}
      hasTransparentOption={false}
      iconType="A"
      tooltipTitle="Font color"
      onSelectColor={selectFontColor}
    />
  );
}
